import { DeleteOutlined } from '@ant-design/icons';
import { Button, Text } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';

import { AdminClientListViewQuery } from '@/@generated/codegen/API';
import PopConfirm from '@/ui/PopConfirm/PopConfirm';
import dateInRangeFilterFn from '@/ui/TanstackTable/Filter/date/dateInRangeFilterFn';
import { parseDate } from '@/utils/helpers/parseDate';

export type AdminClientListItemType =
  AdminClientListViewQuery['listClients']['edges'][number]['node'];

const columnHelper = createColumnHelper<AdminClientListItemType>();

type Args = {
  t: TFunction<'translation', undefined, 'translation'>;
  onDeleteClientClick: (row: AdminClientListItemType) => void;
};

const getColumns = ({ t, onDeleteClientClick }: Args) => {
  const columns = [
    columnHelper.accessor('name', {
      header: 'Client Name',
    }),
    columnHelper.accessor('createdAt', {
      header: 'Created At',
      filterFn: dateInRangeFilterFn,
      cell: (props) => <Text>{parseDate(props.getValue().toString() || '')}</Text>,
    }),
    columnHelper.display({
      id: 'actions',
      header: 'Actions',
      cell: (props) => {
        const item = props.row.original;
        return (
          <PopConfirm
            title={
              <div>
                {t('admin.clients.delete.confirmText')}
                <br />
                {t('meeting.header.confirmRestart')}
              </div>
            }
            onConfirm={() => onDeleteClientClick(item)}
            okText={t('common.yes') || 'Yes'}
            cancelText={t('common.no') || 'No'}
          >
            <Button
              disabled={item.meetings.edges.length > 0}
              variant="danger"
              key="delete"
              size="sm"
              rightIcon={<DeleteOutlined />}
            >
              {t('common.delete')}
            </Button>
          </PopConfirm>
        );
      },
    }),
  ];

  return columns;
};

export default getColumns;
